import Vue from 'vue'
import router from './index'
import store from '@/store'
import { hasAccessToken } from '@/utils/auth'
import { isValidRoutePath, getRootRoute } from '@/utils/routerUtil'

const loginPath = '/user/login'
const dispatchPath = '/user/dispatch'
const notFoundPath = '/404'
const casError = '/user/caserror'
const casSuccess = '/user/cassuccess'
const whitePaths = [loginPath, notFoundPath, dispatchPath, casError, casSuccess]

router.beforeEach((to, from, next) => {
  const path = to.path
  if (!hasAccessToken()) {
    if (whitePaths.indexOf(path) >= 0) {
      next()
      return
    }
    const query = to.query
    const appId = fetchQueryAppId(query)
    const pageId = fetchQueryPageId(query)
    if (path == '/app/review/page' && appId && pageId && !query.config) {
      store.dispatch('getAppInfo', { id: appId }).then(() => {
        store.dispatch('getUserMenus', { appId: appId }).then((res) => {
          const menus = res?.data ?? []
          const find = (list, key) => {
            if (list == null || list.length == 0 || key == null) {
              return null
            }
            for (const l of list) {
              if (l.pageId === key) {
                return l
              }
              const f = find(l.children, key)
              if (f) {
                return f
              }
            }
            return null
          }
          const menu = find(menus, pageId)
          if (menu == null || menu.authType != '0') {
            next({ path: loginPath })
            return
          }
          next()
        })
      })
      return
    }
    next({ path: loginPath })
    return
  }
  if (store.getters.user.hasMenus) {
    toNext(to, next)
    return
  }
  if (whitePaths.indexOf(path) >= 0 && to.query?.token?.length) {
    next()
    return
  }
  store.dispatch('getAppInfo').then(() => {
    store.dispatch('getUserInfo').then(() => {
      store.dispatch('getUserMenus').then(() => {
        toNext(to, next)
      })
    })
  })
})

router.afterEach((to, from) => {
  // to and from are both route objects.
})

const toNext = (to, next) => {
  if (to.path === '/') {
    const root = getRootRoute()
    next({ path: root?.path ?? 'home', replace: true })
    return
  }
  if (isValidRoutePath(to.path)) {
    if (to.matched.length == 0) {
      next({...to, replace: true})
      return
    }
    next()
    return
  }
  if (whitePaths.indexOf(to.path) >= 0) {
    next()
    return
  }
  next({ path: notFoundPath })
}

const fetchQueryAppId = query => {
  const components = query?.pageKey?.split('__') ?? null
  return !components || components.length < 1 ? null : components[0]
}

const fetchQueryPageId = query => {
  const components = query?.pageKey?.split('__') ?? null
  return !components || components.length < 2 ? null : components[1]
}